import React from 'react';
import { InputWrapper, Label, Input, ErrorMessage } from '../../styles/components';

const InputField = ({ 
  label, 
  type = 'text', 
  placeholder, 
  required, 
  error,
  ...props 
}) => {
  return (
    <InputWrapper>
      <Label>{label}</Label>
      <Input
        type={type}
        placeholder={placeholder}
        required={required}
        {...props}
      />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </InputWrapper>
  );
};

export default InputField; 